'use strict'

import VacancyApi from './../../api/vacancy.js'

const state = {
  // {"sap_vacancy_id": 262, "vacancy_id": 3244}
  item: null,
  loading: false,
  error: null,
  changed: false
}

const getters = {
}

const actions = {
  init({commit, rootGetters}) {
    const vacancy = rootGetters['vacancy/one']
    const data = rootGetters['process/deloitteSF/vacancy/SFVacanciesList/getSFVacancyItemByVacancyId'](vacancy.id)
    commit('setSFVacancy', data)
    commit('setChanged', false)
  },
  update ({commit}, data) {
    commit('setSFVacancy', data)
    commit('setChanged', true)
  },

  save ({commit, dispatch, state, rootGetters}) {
    if (!state.changed) {
      // do nothing, because, nothig was changed in object, no need to send save request
      return
    }

    let sapVacancyId
    let vacancyId = null

    if (!state.item) {
      // so that we have deal with unattach of sap id, try to find its in relation list
      const sfVacancyRelation = rootGetters['process/deloitteSF/vacancy/SFVacanciesList/getSFVacancyItemByVacancyId'](
        rootGetters['vacancy/one'].id
      )
      if (sfVacancyRelation) {
        sapVacancyId = sfVacancyRelation.sap_vacancy_id
      }
    } else {
      sapVacancyId = state.item.sap_vacancy_id
      vacancyId = state.item.vacancy_id ? state.item.vacancy_id : null
    }

    if (!sapVacancyId) {
      // no sapVacancyId, no party, because it is a mandatory part of url
      // this case is when we select something, then deselectm and also no relation for it in relation map
      return
    }

    commit('request')
    commit('setChanged', false)
    VacancyApi.saveSFVacancyMap(sapVacancyId, {vacancy_id: vacancyId}).then(data => {
      commit('success', data)
      dispatch('process/deloitteSF/vacancy/SFVacanciesList/update', state.item, {root: true})
    })
    .catch(err => commit('failure', err))
  }
}

const mutations = {
  request (state) {
    state.loading = true
    state.error = null
  },

  failure (state, error) {
    state.loading = false
    state.error = error
  },

  success (state, data) {
    state.loading = false
    // in case of data is not defined, set it as empty object
    if (!state.item) {
      state.item = {}
    }

    // use object assign because data contain not all fields
    state.item = Object.assign(state.item, data)
  },

  setChanged(state, value) {
    state.changed = value
  },

  setSFVacancy(state, item) {
    if (!item) {
      state.item = null
      return
    }

    state.item = {
      sap_vacancy_id: item.sap_vacancy_id,
      vacancy_id: item.vacancy_id
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}